import { Cross } from '@/assets'
import { Container, Typography } from '@cleartrip/ct-design-components'
import { FC } from 'react'

interface EmiOptionsHeaderProps {
    onClose: () => void
}

const EmiOptionsHeader: FC<EmiOptionsHeaderProps> = ({ onClose }) => {
    return (
        <Container className="flex flex-column p-6" style={{ gap: '16px' }}>
            <Container className="c-pointer" onClick={onClose}>
                <Cross />
            </Container>
            <Typography variant="HM1">Credit card EMI options</Typography>
        </Container>
    )
}

export default EmiOptionsHeader
